import { produce } from 'immer';

import { OpenInternalBannersEdit } from '../../../actions/bannersEdit/internal/openInternalBannersEdit';
import { PageStatus } from '../../../typings/common';
import { EditInternalBannersState } from '../../../typings/internalBannersEditState';

export function openInternalBannersEdit(
    state: EditInternalBannersState,
    action: OpenInternalBannersEdit
): EditInternalBannersState {
    return produce(state, draft => {
        draft.pageStatus = PageStatus.LOADING;
        draft.errorsSummary = undefined;
        draft.errors = [];
    });
}
